import React from "react";
import Modal from "../../../../components/__common/Modal/Modal";
import { Typography } from "../../../../components/__common/Typography/Typography";
import "./PrivacyRightsModal.scss";
import { Button } from "../../../../components/__common/_controls";
import Carousel from "nuka-carousel/lib/carousel";
import { useTranslation } from "react-i18next";
import Rights from "./Rights";
import { RegionPrivacyRights } from "../../../../data/landing-page";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { LayoutState } from "../../../../store/reducers/layout-reducer";

interface Props {
  show: boolean;
  onClickClose: () => void;
  country: string;
}

const PrivacyRightsModal: React.FC<Props> = ({
  show,
  onClickClose,
  country,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );

  const renderPrivacyRights = () => {
    if (isRTL) {
      const reversed = RegionPrivacyRights[country].rights.toReversed();

      return reversed.map((right: any) => (
        <Rights key={right} type={right} region={country} />
      ));
    }

    return RegionPrivacyRights[country].rights.map((right: any) => (
      <Rights key={right} type={right} region={country} />
    ));
  };

  return (
    <Modal show={show} className="privacy-rights-modal">
      <Modal.Header onHide={onClickClose}>
        <Modal.Title>{t("PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_TITLE")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="privacy-rights-modal__message">
          <Typography variant="body2" component="p">
            {t("PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_DESC1")}
          </Typography>
          <Typography variant="body2" component="p">
            {t("PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_DESC2")}
          </Typography>
        </div>
        <div dir="ltr">
          <Carousel
            defaultControlsConfig={{
              pagingDotsContainerClassName: "paging-dots",
              pagingDotsClassName: "paging-dots__dot",
            }}
            slideIndex={
              isRTL ? RegionPrivacyRights[country].rights.length - 1 : 0
            }
          >
            {renderPrivacyRights()}
          </Carousel>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          title={t("PRIVACY_MYDATA_USAGE_GUIDE_BTN")}
          onClick={onClickClose}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default PrivacyRightsModal;
